export default "﻿<div class=\"pdfViewerWidget\">\n    <div class=\"fileViewerPdfViewer\" data-dojo-attach-point=\"viewContainer\"></div>\n</div>\n"